import React from 'react'
import SectionHeading from "./../../utilities/SectionHeading"

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';
import { Pagination, Scrollbar } from 'swiper';
import 'swiper/css/pagination';
import "./Project.css"

export default function Project() {

    const ProjectBox = (props) => {
        return (
            <div className="project-container" data-aos="fade-up">
                <a href={props.project_link} target="_blank" rel="noopener noreferrer">
                    <div className="project-box" >
                        <div className="img-box">
                            <img src={require(`./../../static/${props.project_url}.png`)} alt="project" />
                        </div>

                        <div className="project-title">
                            {props.project_title}
                        </div>

                        <div className="project-details">
                            {props.project_desc}
                        </div>

                        <div className="techUsed">
                            {props.project_techs}
                            <div className="year"> {props.project_year} </div>
                        </div>
                    </div>
                </a>
            </div>
        )
    };

    const projects = [
        {
            project_title: "Srijan'23",
            project_desc: "A website for Annual Techno Fest event of Jadavpur University, named SRIJAN where user can login their account, register for events, place order for merchandises and lots of other stuffs.",
            project_techs: "NextJS ReactJS Firebase",
            project_year: "2023",
            project_url: "project12",
            project_link: "https://srijanju.in"
            // project_link: "https://srijan23.netlify.app"
        },
        {
            project_title: "MemoGram",
            project_desc: "A Social Media web-application where user can share their lovely moments, memories with others",
            project_techs: "NextJS ReactJS Firebase",
            project_year: "2023",
            project_url: "project10",
            project_link: "https://memogram-nine.vercel.app"
        },
        {
            project_title: "WiseMeal",
            project_desc: "A Health-Boosting web-application that can track your foods, analyze weekly calories, set goals and also gives a place to share your fitness stories to everyone",
            project_techs: "NodeJS REST-API MongoDB",
            project_year: "2022",
            project_url: "project7",
            project_link: "https://wisemeal.onrender.com"
        },
        {
            project_title: "Pupils' Hub",
            project_desc: "An eficient Hostel Management System to help the students to stay at their hostels efficiently",
            project_techs: "NodeJS REST-API MongoDB",
            project_year: "2022",
            project_url: "project0",
            project_link: "https://pupils-hub.onrender.com"
        },
        {
            project_title: "InfoShare",
            project_desc: "A React based data sharing Web Application where user can share their data in public as well as private mode",
            project_techs: "React MongoDB Netlify",
            project_year: "2022",
            project_url: "project9",
            project_link: "https://infoshare.netlify.app"
        },
        {
            project_title: "Collab",
            project_desc: "Unleash the Power of COLLABoration! Join our innovative platform to create, share & collaborate on notes with your peers, fueling endless inspiration & knowledge exchange",
            project_techs: "React Firebase SocketIO Quill",
            project_year: "2023",
            project_url: "project13",
            project_link: "https://collaab.netlify.app"
        },
        {
            project_title: "Musico",
            project_desc: "Listen your favourite songs with Musico. Here user can play any songs free without even registering an account.",
            project_techs: "NextJS ReactJS",
            project_year: "2023",
            project_url: "project11",
            project_link: "https://musico369.netlify.app"
        },
        {
            project_title: "MovieDB",
            project_desc: "Discover trending, popular, upcoming Hollywood movies at just one click. You can watch trailer and also can add movies to your Favourites",
            project_techs: "React TMDB-API Netlify",
            project_year: "2022",
            project_url: "project8",
            project_link: "https://movie-db369.netlify.app"
        },
        {
            project_title: "Chit-Chat",
            project_desc: "This is a Realtime Chat Application where user can chat with a group of people at the same time.",
            project_techs: "VanillaJS NodeJS SocketIO",
            project_year: "2021",
            project_url: "project4",
            project_link: "https://chit-chat-asng.onrender.com"
        },
        {
            project_title: "Hisab Rakho",
            project_desc: "This is an Expense-Record React based web application where user can save their expense records and view that in a chart form.",
            project_techs: "React Netlify",
            project_year: "2021",
            project_url: "project1",
            project_link: "https://hisab-rakho.netlify.app/"
        },
        {
            project_title: "Arimize Screen",
            project_desc: "This apk allows websites to create a floating video window always on top of other windows to continue consuming media while interacting with other content sites.",
            project_techs: "VanillaJS API",
            project_year: "2021",
            project_url: "project2",
            project_link: "https://arindam369.github.io/arimizeScreen/"
        },
        {
            project_title: "Narutofy",
            project_desc: "This is a Music Player web apk where anyone can listen their favourite Naruto songs at just one click.",
            project_techs: "VanillaJS",
            project_year: "2021",
            project_url: "project3",
            project_link: "https://arindam369.github.io/narutofy/"
        },
        {
            project_title: "Bookmark Library",
            project_desc: "We often want to store many bookmarks but can't do due to limited spaces in browser. This is where my bookmark library web apk comes to store unlimited bookmarks in a page.",
            project_techs: "VanillaJS",
            project_year: "2021",
            project_url: "project5",
            project_link: "https://arindam369.github.io/bookmark-library/"
        },
        {
            project_title: "Custom CountDown",
            project_desc: "We often forget many important things and want to set a timer. It is a Countdown web apk where user can start a countdown after selecting a title, date and time.",
            project_techs: "VanillaJS",
            project_year: "2021",
            project_url: "project6",
            project_link: "https://arindam369.github.io/Countdown/"
        },
    ]

    // breakpoints: {
    //     // when window width is <= 499px
    //     499: {
    //         slidesPerView: 1,
    //         spaceBetweenSlides: 50
    //     },
    //     // when window width is <= 999px
    //     999: {
    //         slidesPerView: 2,
    //         spaceBetweenSlides: 50
    //     }
    // }


    return (
        <div>
            <section id="Projects" data-aos="fade-in">

                <SectionHeading heading="Projects" description="Let's share my works with you" />


                <div className="project-showcase">
                    
                    
                    {projects && projects.length>0 && <Swiper
                        modules={[Pagination, Scrollbar]}
                        spaceBetween={30}
                        slidesPerView={3}
                        pagination={{ clickable: true }}
                        // scrollbar={{ draggable: true }}
                        // onSlideChange={() => console.log('slide change')}
                        // onSwiper={(swiper) => console.log(swiper)}

                        breakpoints={{
                            // when window width is >= 640px
                            100: {
                              width: 400,
                              slidesPerView: 1,
                            },
                            // when window width is >= 768px
                            710: {
                              width: 700,
                              slidesPerView: 2,
                            },
                            1020: {
                              width: 1015,
                              slidesPerView: 3,
                            },
                          }}


                    >

                        {projects && projects.length>0 && projects.map((project, i) => (
                            <SwiperSlide key={i}>
                                <ProjectBox project_title={project.project_title} project_desc={project.project_desc} project_techs={project.project_techs} project_year={project.project_year} project_url={project.project_url} key={`20${i}`} project_link={project.project_link} />

                            </SwiperSlide>
                        ))}
                    </Swiper>}




                </div>



            </section>
        </div>
    )
}
